// extracted by mini-css-extract-plugin
module.exports = {"faqListBlock":"faqList_faqListBlock__2KAaS","textWrapper":"faqList_textWrapper__33_LB","faqList":"faqList_faqList__3qQlb"};